module.exports = __webpack_public_path__ + "img/奖章4级@3x.5aa65110.png";